import { MONTH_NAMES } from '../utils/months';

// Month + year as two dropdowns (Safari has no month input). value / onChange: 'YYYY-MM-01'.
export default function MonthPicker({ value, onChange, style, testId }) {
  const [y, m] = String(value || '').split('-').map(Number);
  const thisYear = new Date().getFullYear();
  const years = [];
  for (let n = Math.min(thisYear - 5, y || thisYear); n <= Math.max(thisYear + 6, y || thisYear); n++) years.push(n);
  const set = (year, month) => onChange(`${year}-${String(month).padStart(2, '0')}-01`);
  const sel = { ...style, width: 'auto', flex: 1 };
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <select style={sel} value={m || ''} onChange={e => set(y || thisYear, e.target.value)} data-testid={testId && `${testId}-month`}>
        {!m && <option value="">Month…</option>}
        {MONTH_NAMES.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
      </select>
      <select style={sel} value={y || ''} onChange={e => set(e.target.value, m || 1)} data-testid={testId && `${testId}-year`}>
        {!y && <option value="">Year…</option>}
        {years.map(n => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
}
